import AppUtils from '@/utils/AppUtils'
import { PortalUtils } from '@/utils/PortalUtils.js'

const dot = require('dot-object')

export default {
  methods: {
    adjustAppLoading (count) {
      this.$store.commit('App/ADJUST_APP_LOADING', count)
    },
    toggleAppTheme () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
    },
    setAppHeaderTitle (title) {
      this.$store.commit('App/SET_APP_HEADER_TITLE', title)
    },
    setAppHeaderColor (color) {
      this.$store.commit('App/SET_APP_HEADER_COLOR', color)
    },
    setAppDocumentTitle (title) {
      title = PortalUtils.portalTitleMapping[PortalUtils.name]
      // if (title !== process.env.APP_TITLE) title += ' | ' + process.env.APP_TITLE

      document.title = title
      this.$store.commit('App/SET_APP_DOCUMENT_TITLE', title)
    },
    appAllowAccess (authenticated = false, roles = [], permissions = []) {
      return AppUtils.allowAccess(authenticated, roles, permissions)
    },
    appToggleFullScreen (element = 'html') {
      AppUtils.toggleFullScreen(element)
    },
    getError (name, error) {
      return error[name] ?? dot.pick(name, error)
    },
    nextInput (elem) {
      if ((elem?.keyCode === 13 || elem?.keyCode === 40) && elem?.target?.form) {
        const currentIndex = Array.from(elem.target.form).indexOf(elem.currentTarget)
        elem.target.form[
          currentIndex < elem.target.form.length - 1
            ? currentIndex + 1
            : 0
        ].focus()
      }
    },
    fileSrc (val) {
      return val ? `${this.$API_URL}download.api?path=${val}` : undefined
    }
  },
  computed: {
    getAppHeaderTitle () {
      return this.$store.getters['App/getAppHeaderTitle']
    },
    getAppHeaderColor () {
      return this.$store.getters['App/getAppHeaderColor']
    },
    getAppDocumentTitle () {
      return this.$store.getters['App/getAppDocumentTitle']
    },
    isAppDebugMode () {
      return AppUtils.isDebugMode()
    },
    isAppFullScreen () {
      return this.$store.getters['App/getAppFullScreen']
    },
    console: () => console
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.setAppHeaderTitle(to.meta.headerTitle ?? to.meta.title ?? to.name)
      vm.setAppDocumentTitle(to.meta.documentTitle ?? to.meta.title ?? process.env.APP_TITLE)
    })
  }
}
